import React from 'react';
import { MapPinIcon } from 'lucide-react';
interface Role {
  title: string;
  description: string;
}
interface Experience {
  company: string;
  location: string;
  roles: Role[];
}
const experiences: Experience[] = [{
  company: 'Katalyst Product Lab',
  location: 'New York, NY',
  roles: [{
    title: 'Founder & Principal Product Consultant',
    description: 'Founded consultancy focused on strategic insights, product vision, and zero-to-one product development for mission-driven startups and non-profits.'
  }]
}, {
  company: 'Verkada',
  location: 'San Francisco, CA',
  roles: [{
    title: 'Product Lead, New Products',
    description: 'Spearheaded end-to-end product strategy, growth experiments, and feature roadmap to grow $55M product line across 15+ SKUs.'
  }]
}, {
  company: 'Productboard',
  location: 'San Francisco, CA',
  roles: [{
    title: 'Product Growth Strategist',
    description: "Devised and implemented product-led growth experimentation plan to drive adoption of SaaS unicorn's new collaborative product roadmapping tool."
  }]
}, {
  company: 'Amazon',
  location: 'Seattle, WA',
  roles: [{
    title: 'Senior Product Manager, Internship',
    description: 'Ideated vision, design and product roadmap of new AI-based interactive FinTech platform as MBA intern by translating SMB seller data insights into personalized business recommendations. Amazon selected and expedited platform for fast-track global launch.'
  }]
}, {
  company: 'Johnson & Johnson',
  location: 'Los Angeles, CA',
  roles: [{
    title: 'Product Manager – Global Product Strategy & Innovation',
    description: 'Led 12 member cross-functional team in strategizing and executing $450M product roadmap; developed 15 personal care products.'
  }, {
    title: 'Assistant Product Manager – 3-Year Rotational Leadership Development Program',
    description: "Selected into J&J's rotational program to accelerate cross-functional leaders; 1st member promoted in advance of 3-year timeline."
  }]
}];
export function ProfessionalJourney() {
  return <section className="py-16 bg-white" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-137">
          My Professional Journey
        </h2>

        <div className="max-w-5xl mx-auto space-y-8" data-id="element-138">
          {experiences.map((exp, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-6 pb-8 border-b border-gray-200 last:border-b-0" data-id="element-139">
              {/* Left: Company & Location */}
              <div className="md:col-span-4" data-id="element-140">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-141">
                  {exp.company}
                </h3>
                <div className="flex items-center text-gray-500 text-sm" data-id="element-142">
                  <MapPinIcon size={14} className="mr-1.5" data-id="element-143" />
                  {exp.location}
                </div>
              </div>

              {/* Right: Roles */}
              <div className="md:col-span-8 space-y-5" data-id="element-144">
                {exp.roles.map((role, roleIndex) => <div key={roleIndex} data-id="element-145">
                    <p className="text-[#0096B4] font-semibold text-base mb-2" data-id="element-146">
                      {role.title}
                    </p>
                    <p className="text-gray-600 leading-relaxed" data-id="element-147">
                      {role.description}
                    </p>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}